import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { PDFDocuments } from 'src/app/types/PDFDocuments';
import { AppService } from 'src/app/app.service';
import { AdobePdfService } from 'src/app/services/adobe-pdf.service';
import { HeroImageComponent } from 'src/app/shared/hero-image/hero-image.component';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { CallOutBoxComponent } from '../../call-out-box/call-out-box.component';

@Component({
  selector: 'app-alternatives',
  imports: [HeroImageComponent, PdfViewerComponent, CallOutBoxComponent],
  templateUrl: './alternatives.component.html',
  styleUrl: './alternatives.component.scss',
})
export class AlternativesComponent
  extends PageLayoutBaseComponent
  implements OnInit, AfterViewInit
{
  pdfDocuments: PDFDocuments[] = [];

  constructor(
    protected override appService: AppService,
    private adobePdfService: AdobePdfService
  ) {
    super(appService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.pdfDocuments = [
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Alternatives-09-29-2025.png',
        url: 'https://vmr-cdn.tdotoutreach.com/content/alternatives/Alternatives-09-29-2025.pdf',
        title: 'Alternatives',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Typical-Sections-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/alternatives/Typical-Section-09-23-2025.pdf',
        title: 'Typical Sections',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Entry-and-Exit-Points-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/alternatives/Entry-and-Exit-Points-09-23-2025.pdf',
        title: 'Entry and Exit Points',
      },
    ];
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adobePdfService.embedMultiplePdfs(this.pdfDocuments);
    }, 100);
  }
}
